import { configureStore } from "@reduxjs/toolkit";
import CommonSlice from "slices/CommonSlice";

export default configureStore({
  reducer: {
    common: CommonSlice,
  },
});
